// console.log(`js/02-components/stickyForm is working`);

const stickyBox = document.querySelector(`.sticky-form`);
const closeButton = document.querySelector(`.close-btn`);
const locationSelectNames = document.querySelectorAll(`.location-select-name`);
const locationSelect = document.querySelector(`.location-select`);
const schoolLeadCaptures = document.querySelectorAll(
  `.sticky-iframe-container`
);

if (stickyBox) {
  stickyBox.addEventListener(`click`, checkStickyBox);
  locationSelectNames.forEach((locationName) => {
    locationName.addEventListener(`click`, locationSelectContent);
    locationName.addEventListener(`click`, changeIframe);
  });
}

function locationSelectContent() {
  let locationSelected = this.textContent;
  locationSelect.textContent = locationSelected;
}

function changeIframe() {
  let selectedSchool = this.dataset.schoolselect;
  schoolLeadCaptures.forEach((schoolIframe) => {
    let selectedIframe = schoolIframe.dataset.schoolname;
    if (selectedIframe === selectedSchool) {
      schoolIframe.style.display = `grid`;
    } else {
      schoolIframe.style.display = `none`;
    }
  });
}

function checkStickyBox() {
  let checkCloseButtonClick = closeButton.contains(event.target);
  if (!stickyBox.classList.contains(`expanded`)) {
    expandStickyForm();
  } else if (
    stickyBox.classList.contains(`expanded`) &&
    checkCloseButtonClick
  ) {
    closeStickyForm();
  }
  document.addEventListener(`click`, checkClick);
}

function checkClick() {
  let checkWhereClick = stickyBox.contains(event.target);
  if (!checkWhereClick) {
    closeStickyForm();
  }
}

function expandStickyForm() {
  stickyBox.classList.add(`expanded`);
}

function closeStickyForm() {
  stickyBox.classList.remove(`expanded`);
}
